"use client";

import { ReactNode, memo } from "react";
import PortalClient from "@/components/portal/Portal";
import { X } from "lucide-react";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    children: ReactNode;
    /** When true, clicking the dark backdrop does not close the modal — only the X button does. Defaults to false (existing behavior). */
    disableBackdropClose?: boolean;
}

const Modal = ({ open, onClose, children, disableBackdropClose = false }: ModalProps) => {
    if (!open) return null;

    return (
        <PortalClient>
            {/* Backdrop */}
            <div
                className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm"
                onClick={disableBackdropClose ? undefined : onClose}
            />

            {/* Modal box */}
            <div className="fixed inset-0 z-50 flex items-center justify-center">
                <div
                    className="relative max-w-4xl rounded-2xl bg-neutral-900 text-white shadow-xl"
                    onClick={(e) => e.stopPropagation()}
                    data-test-id="modal-content"
                >
                    {/* Close button */}
                    <button
                        aria-label="بستن"
                        data-role="close"
                        onClick={onClose}
                        className="absolute left-4 top-4 rounded-full p-2 hover:bg-white/10 cursor-pointer"
                    >
                        <X className="h-5 w-5" />
                    </button>

                    {children}
                </div>
            </div>
        </PortalClient>
    );
};

export default memo(Modal);
